<template>
    <div>
        <header-component></header-component>
        <div class="container g-my-100">
            <div class="reset_password_services">
                <div class="row">
                    <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 offset-sm-0 col-xs-12 offset-sm-0">
                        <div class="reset-password-div" v-if="IsCodeInvalid">
                            <p class="heading">Sorry!</p>
                            <p class="success_msg">
                                Your reset password code is invalid.
                            </p>
                        </div>
                        <div class="reset-password-div" v-if="IsCodeValid">
                            <div v-if="isFormLoading" class="row">
                                <page-loader></page-loader>
                            </div>
                            <div v-else>
                                <div v-if="!isSuccess">
                                    <p class="heading">Forgot Password</p>
                                    <p class="success_msg">
                                        Please enter your new password in the fields below.
                                    </p>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="form-group">
                                                <label class="reset_info_label">New password</label>
                                                <input name="password" v-bind:class="{ error_field: validationResult.AccountPassword, error_field2: hasPasswordError}" type="password" class="form-control login_input" v-on:keyup="CheckPasswordDigits(); CheckMatchPassword()" v-model="ResetNewPassword.Password">
                                                <p v-if="validationResult.AccountPassword" class="error-message">{{validationResult.AccountPassword}}</p>
                                                <!-- REAL TIME VALIDATION -->
                                                <p v-else-if="hasPasswordError && !validationResult.AccountPassword" class="error-message">{{hasPasswordErrorMessage}}</p>
                                            </div>
                                            <div class="form-group">
                                                <label class="reset_info_label">Confirm new password</label>
                                                <input name="confirmPassword" v-bind:class="{ error_field: validationResult.AccountPasswordConfirm, error_field2: hasConfirmPasswordError}" type="password" class="form-control login_input" v-on:keyup="CheckConfirmPasswordDigits(); CheckMatchPassword()" v-model="ResetNewPassword.PasswordConfirm">
                                                <p v-if="validationResult.AccountPasswordConfirm" class="error-message">{{validationResult.AccountPasswordConfirm}}</p>
                                                <!-- REAL TIME VALIDATION -->
                                                <p v-if="hasConfirmPasswordError && !validationResult.AccountPasswordConfirm" class="error-message">{{hasConfirmPasswordErrorMessage}}</p>
                                            </div>
                                            <div class="text-center">
                                              <button class="btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-13" v-on:click="ResetPassword()">Reset Password</button>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                  <p class="heading">Success!</p>
                                  <p class="success_msg">
                                    You can now login to your account by using your new password!
                                    <br>
                                    <a class="g-font-size-20" v-on:click="RedirectHome()">Click here</a> to login.
                                  </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-component></footer-component>
    </div>
</template>
<script>
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";
import PageLoader from "@/components/shared/PageLoader";
export default {
  components: { HeaderComponent, FooterComponent, PageLoader },
  data() {
    return {
      IsCodeValid: false,
      IsCodeInvalid: false,
      validationResult: {},
      isFormLoading: false,
      isSuccess: false,
      ResetNewPassword: {
        code: "",
        Password: "",
        PasswordConfirm: ""
      },
      hasPasswordError: false,
      hasConfirmPasswordError: false,
      hasPasswordErrorMessage: "",
      hasConfirmPasswordErrorMessage: ""
    };
  },
  methods: {
    ValidateCode() {
      axios
        .post("/Account/ResetPassword/" + this.$route.params.code, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          var _this = this;
          if (response.data.isSuccess == true) {
            _this.IsCodeValid = true;
            _this.ResetNewPassword.code = response.data.raw.code;
          } else {
            _this.IsCodeInvalid = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    ResetPassword() {
      this.isFormLoading = true;
      axios
        .post("/Account/ResetPassword", this.ResetNewPassword, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          var _this = this;
          _this.isFormLoading = false;
          if (response.data.isSuccess == true) {
            _this.isSuccess = true;
          } else {
            _this.validationResult = response.data.raw;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    CheckPasswordDigits() {
      var tempAccountPassword = this.validationResult.AccountPassword;
      if (this.ResetNewPassword.Password) {
        if (this.ResetNewPassword.Password.length > 0) {
          this.validationResult.AccountPassword = null;
          if (this.ResetNewPassword.Password.length < 6) {
            this.hasPasswordError = true;
            this.hasPasswordErrorMessage =
              "Password must be at least 6 characters";
          } else {
            this.hasPasswordError = false;
            this.hasPasswordErrorMessage = "";
          }
        }
      } else {
      }
    },
    CheckConfirmPasswordDigits() {
      var tempAccountPassword = this.validationResult.AccountPasswordConfirm;
      if (this.ResetNewPassword.PasswordConfirm) {
        if (this.ResetNewPassword.PasswordConfirm.length > 0) {
          this.validationResult.AccountPasswordConfirm = null;
          if (this.ResetNewPassword.PasswordConfirm.length < 6) {
            this.hasConfirmPasswordError = true;
            this.hasConfirmPasswordErrorMessage =
              "Password must be at least 6 characters";
          } else {
            this.hasConfirmPasswordError = false;
            this.hasConfirmPasswordErrorMessage = "";
          }
        }
      } else {
      }
    },
    CheckMatchPassword() {
      var tempAccountPassword = this.validationResult.AccountPassword;
      var tempAccountPasswordConfirm = this.validationResult
        .AccountPasswordConfirm;
      if (
        this.ResetNewPassword.Password &&
        this.ResetNewPassword.PasswordConfirm
      ) {
        if (
          this.ResetNewPassword.Password.length > 0 &&
          this.ResetNewPassword.PasswordConfirm.length > 0
        ) {
          this.validationResult.AccountPassword = null;
          this.validationResult.AccountPasswordConfirm = null;
          if (
            this.ResetNewPassword.Password ==
            this.ResetNewPassword.PasswordConfirm
          ) {
            this.hasPasswordError = false;
            this.hasConfirmPasswordError = false;
            this.hasConfirmPasswordErrorMessage = "";
            this.CheckPasswordDigits();
            this.CheckConfirmPasswordDigits();
          } else {
            this.hasPasswordError = true;
            this.hasConfirmPasswordError = true;
            this.hasConfirmPasswordErrorMessage = "Password does not match";
          }
        }
      } else {
      }
    },
    RedirectHome() {
        window.location.href="/";
    }
  },
  created() {
    this.ValidateCode();
  }
};
</script>


// WEBPACK FOOTER //
// ResetPassword.vue?21d0aca1